import {BrowserRouter, useRoutes} from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import NotFoundPage from "./pages/NotFoundPage";
import { RecoilRoot } from "recoil";
import * as Middleware from "./middleware/App";
import React from "react";
import UsersPage from "./pages/UsersPage";
import QuizListPage from "./pages/QuizListPage";
import QuizAddPage from "./pages/QuizAddPage";
import QuizDetailPage from "./pages/QuizDetailPage";
import ContentListPage from "./pages/ContentListPage";
import ContentAddPage from "./pages/ContentAddPage";
import ContentDetailPage from "./pages/ContentDetailPage";
import ContentAnalyticPage from "./pages/ContentAnalyticPage";

const RouteApp = () => {
  let routes = useRoutes([
    { path: "/", element: <Middleware.Auth render={<DashboardPage />} /> },
    { path: '/contents', element: <Middleware.Auth render={<ContentListPage/>} /> },
    { path: '/contents/add', element: <Middleware.Auth render={<ContentAddPage/>} /> },
    { path: '/contents/:contentId', element: <Middleware.Auth render={<ContentDetailPage/>} /> },
    { path: '/contents/:contentId/analytic', element: <Middleware.Auth render={<ContentAnalyticPage/>} /> },
    { path: '/quizzes', element: <Middleware.Auth render={<QuizListPage/>} /> },
    { path: '/quizzes/add', element: <Middleware.Auth render={<QuizAddPage/>} /> },
    { path: '/quizzes/:quizId', element: <Middleware.Auth render={<QuizDetailPage/>} /> },
    { path: "/users", element: <Middleware.Auth render={<UsersPage />} /> },
    // { path: "/settings", element: <Middleware.Auth render={<SettingsPage />} /> },
    { path: "/login", element: <Middleware.Guest render={<LoginPage />} /> },
    { path: "*", element: <NotFoundPage /> },
  ]);
  return routes;
}

function App() {
  return (
    <RecoilRoot>
      <BrowserRouter>
          <RouteApp />
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default App;
